import {
    STAFF_CREATED,
    STAFF_ERROR,
    STAFF_DELETE,
    STAFF_UPDATED,
    STAFF_LIST_UPDATED,
    GET_STAFF_BY_ID,
    STAFF_SEARCH_PARAMATERS_UPDATE,
    CHANGE_STAFF_STATUS,
    LOADING_ON_STAFF_SUBMIT,
    RESET,
    LOAD_PAGE,
    LOADING_STAFF_LIST_DATA,
  } from "actions/types";
  import * as Constants from "constants/index";

  const initialState = {
    staffList: {
      page: 1,
      data: [],
      count: 0
    },
    currentStaff: null,
    loadingStaffList: true,
    loadingStaff: true,
    loadingListData: true,
    performDelete: false,
    error: {},
    sortingParams: {
      limit: Constants.DEFAULT_PAGE_SIZE,
      page: 1,
      orderBy: "created_at",
      ascending: "desc",
      query: "",
      filters:[],
    }
  };

  export default function(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case RESET:
        return {
          ...initialState,
          loadingStaff: state.loadingStaff,
          loadingStaffList: state.loadingStaffList,
          loadingListData: state.loadingListData,
        }
      case LOAD_PAGE:
        return {
          ...state,
          loadingStaff: false
        };
      case STAFF_CREATED:
        return {
          ...state,
          loadingStaff: false
        };
      case STAFF_UPDATED:
        return {
          ...state,
          currentStaff: payload,
          sortingParams: initialState.sortingParams,
          loadingStaff: false,
        };
      case STAFF_DELETE:
        const currentCount = state.staffList.count;
        const currentLimit = state.sortingParams.limit;
        const currentPage = parseInt(state.staffList.page);
        let remainingPages = Math.ceil((currentCount - 1)/currentLimit);
      remainingPages = remainingPages?remainingPages:1;
        return {
          ...state,
          staffList: {
            data: state.staffList.data.filter(staff =>
              staff._id !== payload
            ),
            count: currentCount - 1,
            page: currentPage <= remainingPages?currentPage.toString(): remainingPages.toString(),
          },
          loadingStaffList: false,
          performDelete: true,
        };
      case STAFF_ERROR:
        return {
          ...state,
          error: payload,
          loadingStaff: false,
          loadingStaffList: false,
          loadingListData: false,
          performDelete: false,
        };
      case GET_STAFF_BY_ID:
        return {
          ...state,
          currentStaff: payload,
          loadingStaff: false,
        };
      case STAFF_LIST_UPDATED:
        return {
          ...state,
          staffList: {
            data: payload.data,
            page: payload.metadata[0].current_page,
            count: payload.metadata[0].totalRecord
          },
          // loadingStaff: true,
          loadingStaffList: false,
          loadingListData: false,
          performDelete: false,
        };
      case STAFF_SEARCH_PARAMATERS_UPDATE:
        return {
          ...state,
          sortingParams: { ...payload }
        };
      case CHANGE_STAFF_STATUS:
        return {
          ...state,
          loadingListData: false,
          staffList: {
            ...state.staffList,
            data: state.staffList.data.map(staff =>
              staff._id === payload._id
                ? { ...staff, status: payload.status }
                : staff
            )
          }
        };
      case LOADING_STAFF_LIST_DATA:
        return {
          ...state,
          loadingListData: true
        };
      case LOADING_ON_STAFF_SUBMIT:
        return {
          ...state,
          loadingStaff: true
        };
      default:
        return state;
    }
  }
